import React, { memo, useCallback } from 'react';
import { ContentPreview } from 'reaxl-molecules';

import {
    Image,
    PageSection,
    Text,
    Link,
} from 'reaxl';

import { callToActionAnalytics } from '@/analytics';
import { additionalServicesContent } from '@/reference';

const contentMediaClassName = 'content-media-placeholder-height';
function ContentMediaPlaceHolderStyle() {
    return (
        <style type="text/css">
            {`       
            .${contentMediaClassName} {
                min-width: 104px;
                min-height: 100px;
            }
        `}
        </style>
    );
}

const renderBody = (title, summary, link, index) => {
    const { label } = link;
    return (
        <div className="display-flex flex-column margin-left-1">
            <div
                data-qaid={`at-service-header-${index}`}
                className="text-bold text-gray-base margin-bottom-1"
            >
                <h3 className="text-bold text-size-400 text-size-sm-500">{title}</h3>
            </div>
            <Text
                className="text-gray-base"
                data-qaid={`at-service-copy-${index}`}
            >
                {summary}
            </Text>
            <span
                className="text-link display-block"
            >
                {label}
            </span>
        </div>
    );
};

const renderImage = (image) => (
    <Image
        className="margin-left-sm-auto"
        src={image.src}
        alt={image.alt}
        lazyload
        {...image}
    />
);

const renderContent = (content) => content.map((details, index) => {
    const { title, image, summary, link, cmp } = details;

    const handleLinkClick = useCallback((e) => {
        callToActionAnalytics.fireAdditionalServicesLinkClick(e, {
            cmp,
            coTxtUrl: link.label,
        });
    }, [cmp, link.label]);

    return (
        <div
            className="col-sm-6 col-xs-12 margin-vertical-2 padding-horizontal-3"
            key={index}
            data-qaid={`at-service-container-${index}`}
        >
            <Link
                className="link-unstyled display-block"
                href={link && link.href}
                onClick={handleLinkClick}
                data-qaid={`at-service-link-${index}`}
            >
                <ContentPreview
                    image={renderImage(image)}
                    headline={renderBody(title, summary, link, index)}
                    orientation="landscape"
                    mediaClassName={contentMediaClassName}
                />
            </Link>
        </div>
    );
});

const AdditionalServicesContainer = memo(() => (
    <PageSection
        coloredBackgroundContext="default"
        alignment="left"
        offset={1}
    >
        <ContentMediaPlaceHolderStyle />
        {renderContent(additionalServicesContent)}
    </PageSection>
));

export default AdditionalServicesContainer;
